import DatricRequests from '../datric.requests';
import { CardQuote, Payment } from '../../../models/payment.model';

const requests = new DatricRequests();

export async function createPixPayment(amountBRL: number): Promise<Payment> {
	return requests.post('payments/pix', { amountBRL });
}

export async function quoteCardPayment(credits: number): Promise<CardQuote> {
	return requests.get('payments/card/quote', { credits });
}

export async function createCardPayment(credits: number): Promise<Payment> {
	return requests.post('payments/card', { credits });
}

export async function listPayments(): Promise<Payment[]> {
	return requests.get('payments');
}

export async function getPayment(id: string): Promise<Payment> {
	return requests.get(`payments/${id}`);
}
